import axios from 'axios';
import React, { useState, useEffect } from 'react';
import auth from '../auth/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faFlag } from '@fortawesome/free-solid-svg-icons';

const UsersManagement = () => {
  const [users, setUsers] = useState([]);
  const [flaggedUsers, setFlaggedUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [flagReason, setFlagReason] = useState('');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API}/utilisateurs`, { headers: auth() })
      .then((res) => {
        setUsers(res.data);
      })
      .catch((error) => {
        console.log('Erreur lors de la récupération des utilisateurs:');
      });
  }, []);

  const handleDelete = async (userId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API}/supprimer-utilisateur/${userId}`, { headers: auth() });
      setUsers((prevUsers) => prevUsers.filter((user) => user._id !== userId));
    } catch (error) {
      console.log('Erreur de la suppression de lutilisateur:');
    }
  };

  const handleFlag = (userId) => {
    setSelectedUserId(userId);
    const reason = prompt('Veuillez entrer le motif de signalement :');
    if (reason) {
      setFlagReason(reason);
      setFlaggedUsers((prevFlaggedUsers) => [
        ...prevFlaggedUsers,
        {
          userId,
          userName: users.find((user) => user._id === userId)?.login || '',
          userEmail: users.find((user) => user._id === userId)?.email || '',
          reason,
        },
      ]);
      setSelectedUserId(null);
      setFlagReason('');
    }
  };

  return (
    <main>
      <section>
        <h2 className='heading'>Management des utilisateurs</h2>
        <h3>Nombre total d'utilisateurs : {users.length}</h3>
        <table className="user-table">
          <thead>
            <tr>
              <th className="user-id">L'Id de l'utilisateur</th>
              <th className="user-login">Le username</th>
              <th className="user-email">L'email</th>
              <th className="user-role">Le rôle</th>
              <th className='user-actions'>Action(s)</th>
            </tr>
          </thead>
          <tbody>
          {users.map((user) => (
              <tr key={user._id}>
                <td>{user._id}</td>
                <td>{user.login}</td>
                <td>{user.email}</td>
                <td>{user.role}</td>
                <td>
                  <button className="delete-button" onClick={() => handleDelete(user._id)}>
                    <FontAwesomeIcon icon={faTrash} className="trash-icon" />
                  </button>
                  <button className="flag-button" onClick={() => handleFlag(user._id)}>
                    <FontAwesomeIcon icon={faFlag} className="flag-icon" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section>
        <h2 className='heading'>Utilisateurs Signalés</h2>
        <h3>Nombre d'utilisateurs signalés : {flaggedUsers.length}</h3>
        <table className="user-table">
          <thead>
            <tr>
              <th className="user-id">L'Id de l'utilisateur</th>
              <th className="user-login">Le username</th>
              <th className="user-email">L'email</th>
              <th className="user-actions">Raison</th>
            </tr>
          </thead>
          <tbody>
            {flaggedUsers.map((flaggedUser) => (
              <tr key={flaggedUser.userId}>
                <td>{flaggedUser.userId}</td>
                <td>{flaggedUser.userName}</td>
                <td>{flaggedUser.userEmail}</td>
                <td>{flaggedUser.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </main>
  );
};

export default UsersManagement;
